<script>
import { GlFormGroup, GlFormSelect } from '@gitlab/ui';
import { ValidationProvider } from 'vee-validate';
import validationStateMixin from '~/javascripts/forms/validation/mixins/validation_state_mixin';
import { EMPLOYEES_COUNT } from '~/javascripts/sessions/sessions_constants';

export default {
  name: 'CompanySizeField',
  components: {
    ValidationProvider,
    GlFormGroup,
    GlFormSelect,
  },
  mixins: [validationStateMixin],
  props: {
    groupClass: {
      type: [String, Object, Array],
      required: false,
      default: '',
    },
    value: {
      type: String,
      required: false,
      default: '',
      validator: (value) => EMPLOYEES_COUNT.find((item) => item.value === value) || value === '',
    },
  },
  emits: ['input', 'blur'],
  data() {
    return {
      // `GlFormSelect` only seem to trigger validation when using v-model, not when value is passed directly
      form: {
        value: this.value,
      },
    };
  },
  EMPLOYEES_COUNT,
};
</script>

<template>
  <validation-provider
    #default="validationContext"
    name="Total number of employees"
    rules="required"
    slim
  >
    <gl-form-group
      :class="groupClass"
      data-testid="company-size"
      label="Total number of employees"
      label-for="company-size"
      :invalid-feedback="validationContext.errors[0]"
      :state="getValidationState(validationContext)"
    >
      <gl-form-select
        id="company-size"
        v-model="form.value"
        data-testid="company-size-input"
        name="customer[company_size]"
        :options="$options.EMPLOYEES_COUNT"
        :state="getValidationState(validationContext)"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <template #first>
          <option value="" disabled selected>Please select</option>
        </template>
      </gl-form-select>
    </gl-form-group>
  </validation-provider>
</template>
